import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { LandingsPropTypes } from '@mssgme/ui';
import { productsApi } from '@mssgme/lib';
import { useOrderProducts, useWebsiteData } from '../../hooks';
import { Divider } from '../Divider';
import { OrderItem } from './OrderItem';

import styles from './OrderItem.scss';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    onAdjust: PropTypes.func,
};

export function OrderItemsList({ order, onAdjust, ...rest }) {
    const website = useWebsiteData();
    const products = useOrderProducts(
        website,
        order,
        useCallback(({ productId }) => productsApi.load(website.workspace, productId), [])
    );

    return (
        <div {...rest}>
            <Divider style={{ marginBottom: 0 }} />
            <ul className={styles.list}>
                {products.map((item) => (
                    <OrderItem key={item._id} item={item} onAdjust={onAdjust} />
                ))}
            </ul>
            <Divider style={{ marginTop: 0 }} />
        </div>
    );
}

OrderItemsList.propTypes = propTypes;
